<template>
  <page>
    <template slot="content">
    <help-content :title="'バッテリーの持ち時間について'">
      <template slot="content">
        <div class="text">
          WeBandがフル充電された場合、バッテリーは2週間～3週間持ちます。<br><br>
          ただし、使い方によって２週間以下の場合もあります。電話やSNSの着信通知、自動点灯設定をONにした場合はバッテリーの消耗が早くなります。<br><br>
          WeBand本体に表示されているバッテリーマークが点滅したら（またはアプリのWeBandボタンに表示されている残量が20％以下になったら）、必ず2～3時間以上充電してください。充電時間が短いとフル充電されない可能性があります。
        </div>
      </template>
    </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help18.vue